import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Container, Row, Col } from 'react-bootstrap';
import CustomCloseButton from '../Components/CustomCloseButton';
import { useAuth } from '../Context/AuthContext';
import { toast } from 'react-toastify';

import {inputMaxLengths} from '../HelperFunctions/InputMaxLengths';

import { getFunctions, httpsCallable } from "firebase/functions";

import { db } from '../firebase-config';
import { collection, getDocs } from 'firebase/firestore';

const CreateRequestModal = (props)=>{
    const { setShowSpinner } = useAuth();
    const [address, setAddress] = useState("");
    const [projectName, setProjectName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [clientName, setClientName] = useState("");
    const [emailAddress, setEmailAddress] = useState("");
    const [requestType, setRequestType] = useState(props.modal_type);
    const [typeOfService, setTypeOfService] = useState("");
    const [details, setDetails] = useState("");
    const [emailTooltip, setEmailTooltip] = useState('');

    const [chosenClient, setChosenClient] = useState({id: ''});
    const [chosenClientLocationID, setChosenClientLocationID] = useState('');
    const [clientInfo, setClientInfo] = useState([]);
    // use form ref to clear selection
    const [locationDropDownDOM, setLocationDropDownDOM] = useState(null);

    const emailReg = /[A-Za-z0-9._+-]+@[A-Za-z0-9 -]+\.[a-z]{2,}/g;

    useEffect(()=>{
        setShowSpinner(true)
        // ------ SEE EMPLOYEE ADMIN SETTINGS PAGE
        // load all clients from database
        getDocs(collection(db, "client_information")).then((snapShot)=>{
            // go through each client and set array of all clientInfo
            let tempClientInfo = [{id: ''}];
            snapShot.forEach((doc)=>{
                tempClientInfo.push({...doc.data(), id: doc.id});
            })
            tempClientInfo.sort((a,b)=>{
                if(a.Customer < b.Customer) return -1;
                if(a.Customer > b.Customer) return 1;
                return 0;
            })
            setClientInfo(tempClientInfo);
            setShowSpinner(false);
        }).catch((error)=>{
            setShowSpinner(false);
            toast.error(`Error getting client list: ${error.message}`);
        });
    }, [setShowSpinner]);

    const findChosenClientInfoFromID = ((id)=>{
        console.log(clientInfo.find((client)=> client.id === id))
        return clientInfo.find((client)=> client.id === id)
    });

    const findAddressFromLocationID = ((client_id, loc_id)=>{
        const client = findChosenClientInfoFromID(client_id);
        const location = client.Locations.find((loc)=> loc.id === loc_id)
        return location?.Address;
    });

    const findCustomerNameFromID = ((client_id)=>{
        const client = findChosenClientInfoFromID(client_id);
        return client?.Customer;
    });

    const updateForm = (locationIndex) =>{
        if(chosenClient?.Locations !== undefined || chosenClient?.Locations.length !== 0){
            if(locationIndex !== undefined && locationIndex !== '' && !isNaN(locationIndex)){
                console.log(locationIndex)
                console.log(chosenClient.Locations[locationIndex]?.id === undefined ? "" : chosenClient.Locations[locationIndex].id)
                setChosenClientLocationID(chosenClient.Locations[locationIndex]?.id === undefined ? "" : chosenClient.Locations[locationIndex].id)
                setProjectName(chosenClient.Locations[locationIndex]?.ProjectName === undefined ? "" : chosenClient.Locations[locationIndex].ProjectName);
                setAddress(chosenClient.Locations[locationIndex]?.Address === undefined ? "" : chosenClient.Locations[locationIndex].Address);
                setPhoneNumber(chosenClient.Locations[locationIndex]?.["Phone Number"] === undefined ? "" : chosenClient.Locations[locationIndex]["Phone Number"]);
                setClientName(chosenClient.Locations[locationIndex]?.["Client Name"] === undefined ? "" : chosenClient.Locations[locationIndex]["Client Name"]);
                setEmailAddress(chosenClient.Locations[locationIndex]?.["Email Address"] === undefined ? "" : chosenClient.Locations[locationIndex]["Email Address"]);
                setRequestType(props.modal_type);
                setTypeOfService("");
                setDetails("");
                setEmailTooltip('');
            }else{
                clearForm();
            }
        }else{
            clearForm();
        }
    }

    const clearForm = ()=>{
        if(locationDropDownDOM !== null){
            locationDropDownDOM.reset();
        }
        setChosenClientLocationID('');
        setProjectName("");
        setAddress("");
        setPhoneNumber("");
        setClientName("");
        setEmailAddress("");
        setRequestType(props.modal_type);
        setTypeOfService("");
        setDetails("");
        setEmailTooltip('');
    }
  
    const validateForm = ()=>{
        if (clientName !== '' && phoneNumber !== '' && address !== '' && emailTooltip === '') {
            setShowSpinner(true);
            // console.log(findAddressFromLocationID(chosenClient?.id, chosenClientLocationID) === address ? chosenClientLocationID : '')
            const functions = getFunctions();
            const clientRequest = httpsCallable(functions, 'clientRequest');
            clientRequest({
                status: 1,
                client_id: chosenClient?.id === undefined ? '' : chosenClient.id,
                client_location_id: findAddressFromLocationID(chosenClient?.id, chosenClientLocationID) === address ? chosenClientLocationID : '',
                client: findCustomerNameFromID(chosenClient?.id) === undefined ? '' : findCustomerNameFromID(chosenClient?.id),                type: requestType,
                'project name': projectName,
                'client name': clientName,
                'email address': emailAddress,
                'phone number': phoneNumber,
                address: address,
                'type of service': requestType === 'quote' ? 'not applicable - Quote' : typeOfService,
                details: details,      
            }).then((response)=>{
                setShowSpinner(false);
                if(response.data.info === 'request added'){
                    toast.success(`New request created for: ${address} with ID - ${response.data.id}`);
                    setProjectName("")
                    setAddress("");
                    setPhoneNumber("");
                    setClientName("");
                    setEmailAddress("");
                    setRequestType(props.modal_type);
                    setTypeOfService("");
                    setDetails("");
                    setEmailTooltip('');
                    setChosenClient({id: ''});
                    setChosenClientLocationID('');
                    props.onHide();
                }else{
                    toast.error(`Could not submit request for: ${address}. Please contact admin.`);
                }
            }).catch((error)=>{
                setShowSpinner(false);
                toast.error(`Could not submit request for: ${address}. Please contact admin.`);
            });
        }else{
            toast.warn('Not all required information is filled out. Please review form.');
        }
    };

    return(
        <Modal
            {...props}
            size="lg"
            animation={false}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header>
                <Modal.Title>
                    {
                        props.modal_type === 'construction' ?
                            'CREATE CONSTRUCTION JOB'
                        :
                            props.modal_type !== undefined & props.modal_type === 'service' ?
                                'CREATE NEW REQUEST - Service Request/Repairs'
                            :
                                props.modal_type === 'maintenance' ?
                                    'CREATE NEW REQUEST - Maintenance'
                                :
                                    ''
                    }
                </Modal.Title>
                <div onClick={()=>{
                    setProjectName("");
                    setAddress("");
                    setPhoneNumber("");
                    setClientName("");
                    setEmailAddress("");
                    setRequestType(props.modal_type);
                    setTypeOfService("");
                    setDetails("");
                    setEmailTooltip('');
                    setChosenClient({id: ''});
                    setChosenClientLocationID('');
                    props.onHide('show cancel')
                }} variant="none">
                    <CustomCloseButton/>
                </div>
            </Modal.Header>
            <Modal.Body>
                <Container fluid style={{marginTop:"20px"}}>
                    <Row>
                        <Col lg="12" style={{border:"1px solid black", padding:"10px", borderRadius:"10px", marginBottom:"5px"}}>
                            <div className="w-100" style={{maxWidth: "600px"}}>
                                <div className="mt-3">
                                    <Form.Group  style={{textAlign:"left"}} id="set-client-list">
                                        <Form.Label>Choose Customer From List: (Optional)</Form.Label>
                                        <Form.Select onChange={(event)=>{
                                            const loc = findChosenClientInfoFromID(event.target.value)
                                            setChosenClient(loc);
                                            clearForm();
                                        }}>
                                            {
                                                clientInfo.map((client, index)=>{
                                                    return(
                                                        <option key={index} value={client.id}>
                                                            {client?.["Customer"] === undefined ? "" : client?.["Customer"]}
                                                        </option>
                                                    )
                                                })
                                            }
                                        </Form.Select>
                                    </Form.Group>
                                </div>
                            </div>
                            {
                                chosenClient?.Locations !== undefined &&
                                    chosenClient?.Locations.length > 0 ?
                                        <div className="w-100" style={{maxWidth: "600px"}}>
                                            <div className="mt-3">
                                                <Form ref={(form) => setLocationDropDownDOM(form)}>
                                                    <Form.Group  style={{textAlign:"left"}} id="set-client-list">
                                                        <Form.Label>Choose Location:</Form.Label>
                                                        <Form.Select onChange={(event)=>{
                                                                updateForm(parseInt(event.target.value))
                                                            }}>
                                                            <option value=''></option>
                                                            {
                                                                chosenClient.Locations.map((location, index)=>{
                                                                    return(
                                                                        <option key={index} value={index}>
                                                                            {location?.Address !== undefined ? location.Address : ''}
                                                                        </option>
                                                                    )
                                                                })
                                                            }
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Form>
                                            </div>
                                        </div>
                                    :
                                        <div className="w-100" style={{maxWidth: "600px"}}>
                                            <div className="mt-3">
                                                <Form.Group  style={{textAlign:"left"}} id="set-client-list">
                                                    <Form.Label>Choose Location:</Form.Label>
                                                    <Form.Select>
                                                        <option value=''></option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </div>
                                        </div>
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="12" style={{border:"1px solid black", padding:"10px", borderRadius:"10px", marginBottom:"5px"}}>
                            <Row style={{marginBottom: "20px"}}><Col>REQUEST DETAILS</Col></Row>
                            {
                                props.modal_type !== undefined && props.modal_type === 'construction' &&
                                    <Row style={{marginLeft:"10px"}}><Col>PROJECT NAME:*</Col></Row>
                            }
                            {
                                props.modal_type !== undefined && props.modal_type === 'construction' &&
                                    <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={projectName} maxLength={inputMaxLengths.serviceAt} onChange={(e)=> setProjectName(e.target.value)}/></Col></Row>
                            }
                            <Row style={{marginLeft:"10px"}}><Col>SERVICE AT:*</Col></Row>
                            <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={address} maxLength={inputMaxLengths.serviceAt} onChange={(e)=> setAddress(e.target.value)}/></Col></Row>
                            <Row style={{marginLeft:"10px"}}><Col>CUST. PHONE No.*</Col></Row>
                            <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={phoneNumber} maxLength={inputMaxLengths.custPhoneNo} onChange={(e)=> setPhoneNumber(e.target.value)} /></Col></Row>
                            <Row style={{marginLeft:"10px"}}><Col>CUST. AUTHORIZATION/CONTACT:*</Col></Row>
                            <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={clientName} maxLength={inputMaxLengths.custAuthContact} onChange={(e)=> setClientName(e.target.value)} /></Col></Row>
                            <Row style={{marginLeft:"10px"}}>
                                <Col>CUST. AUTHORIZATION/CONTACT EMAIL ADDRESS:
                                { 
                                    props.modal_type !== undefined && props.modal_type === 'service' &&
                                        <span>(will email customer if filled out)</span>
                                }
                            </Col></Row>
                            <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}>
                                <Col>
                                    <Form.Control
                                        type="text"
                                        value={emailAddress}
                                        onChange={(e) => {
                                            if (emailReg.test(e.target.value) === false && e.target.value !== '') {
                                                setEmailTooltip('Not a valid email format, must have an @ sign and a .');
                                            } else {
                                                setEmailTooltip('');
                                            }
                                            setEmailAddress(e.target.value)
                                        }} 
                                    />
                                </Col>
                            </Row>
                            <Row style={{color:'red', display:'flex', justifyContent:'center'}}>{emailTooltip}</Row>
                            <Row style={{marginLeft:"10px"}}><Col>REQUEST TYPE:*</Col></Row>
                            <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}>
                                {
                                    props.modal_type !== undefined && props.modal_type === 'service' &&
                                        <Col>
                                            <Form.Select as="select" value={requestType} onChange={(e)=> setRequestType(e.target.value)} required>
                                                <option value={'service'}>service</option>
                                                <option value={'quote'}>quote</option>
                                            </Form.Select>
                                        </Col>
                                }
                                {
                                    props.modal_type !== undefined && props.modal_type === 'maintenance' &&
                                        <Col>
                                            <Form.Select as="select" value={requestType} onChange={(e)=> setRequestType(e.target.value)} required disabled>
                                                <option value={'maintenance'}>maintenance</option>
                                            </Form.Select>
                                        </Col>
                                }
                                {
                                    props.modal_type !== undefined && props.modal_type === 'construction' &&
                                        <Col>
                                            <Form.Select as="select" value={requestType} onChange={(e)=> setRequestType(e.target.value)} required disabled>
                                                <option value={'maintenance'}>construction</option>
                                            </Form.Select>
                                        </Col>
                                }
                            </Row>
                            {
                                requestType === 'service' ?
                                    <div>
                                        <Row style={{marginLeft:"10px"}}><Col>TYPE OF SERVICE:</Col></Row>
                                        <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}>
                                            <Col>
                                                <Form.Select as="select" value={requestType === 'quote' ? '' : typeOfService} onChange={(e)=> setTypeOfService(e.target.value)} required>
                                                    <option value={''}></option>
                                                    <option value={'No Heat'}>No Heat</option>
                                                    <option value={'No AC'}>No AC</option>
                                                    <option value={'Other (please provide details)'}>Other (please provide details)</option>    
                                                </Form.Select> 
                                            </Col>
                                        </Row>
                                    </div>
                                : requestType === 'maintenance' ?
                                    <div>
                                        <Row style={{marginLeft:"10px"}}><Col>TYPE OF SERVICE:</Col></Row>
                                        <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}>
                                            <Col>
                                                <Form.Select
                                                    as="select"
                                                    value={typeOfService}
                                                    onChange={(e)=> {
                                                        setTypeOfService(e.target.value);
                                                        if(e.target.value === "Heating" || e.target.value === "Cooling"){
                                                            setDetails('PM & Inspection of RTUs')
                                                        }else{
                                                            setDetails('');
                                                        }
                                                    }}
                                                    required
                                                    >
                                                        <option value={''}></option>
                                                        <option value={'Heating'}>Heating</option>
                                                        <option value={'Cooling'}>Cooling</option>
                                                        <option value={'Other (please provide details)'}>Other (please provide details)</option>    
                                                </Form.Select> 
                                            </Col>
                                        </Row>
                                    </div>
                                :
                                    <div></div>
                            }
                            <Row style={{marginLeft:"10px"}}><Col>Details:</Col></Row>
                            <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control as="textarea" value={details} rows={3} maxLength={inputMaxLengths.details} onChange={(e)=> setDetails(e.target.value)} /></Col></Row>
                            <Row style={{display:'flex', justifyContent:'center'}}>{inputMaxLengths.details - details.length} characters remaining</Row>
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Button 
                    className="btn-dark"
                    style={{backgroundColor:"#2596be"}}
                    onClick={()=>{
                        validateForm(props);
                    }}
                >
                    Save
                </Button>
                <Button 
                    className="btn-dark"
                    style={{backgroundColor:"#2596be"}}
                    onClick={()=>{
                        setProjectName("");
                        setAddress("");
                        setPhoneNumber("");
                        setClientName("");
                        setEmailAddress("");
                        setRequestType(props.modal_type);
                        setTypeOfService("");
                        setDetails("");
                        setEmailTooltip('');
                        setChosenClient({id: ''});
                        setChosenClientLocationID('');
                        props.onHide('show cancel');
                    }}
                >
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    )
};

export default CreateRequestModal;